var React = require('react');

function Home (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","stroke":"#2185D0","strokeWidth":"15"},[React.createElement("path",{"strokeLinejoin":"round","d":"M8 71L118 8l110 63h-20v123H27V71H8z","key":0}),React.createElement("path",{"d":"M94 122h48v72H94z","key":1})]));
}

Home.defaultProps = {"viewBox":"0 0 236 202"};

module.exports = Home;

Home.default = Home;
